import { HttpClient, type HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { type StatusValues } from '../constants/process';
import { type CompanyServices } from '../models/company';
import { type IErrorObj } from '../models/error.model';

export interface ProcessStatus {
  status: StatusValues;
  errors: IErrorObj[];
  rowsUploaded: number;
  rowsRejected: number;
  advance: number;
  phase: number;
}

export interface LastProcessStatus {
  id: number;
  status: StatusValues;
  advance: number;
  phase: number;
}

export type LoadFileProcess = {
  idProcess: number;
};

@Injectable()
export class ExcelService {
  http = inject(HttpClient);

  private readonly URI_API: string = environment.END_POINT;
  public statusUpload = false;
  public service: Partial<CompanyServices> = null;
  public idProcess = 0;
  public errores: IErrorObj[] = [];

  UploadExcel(files: File[]) {
    this.statusUpload = true;
    this.errores = [];
    const url = `${this.URI_API}/debt/load/${this.service.name}`;
    const formData = new FormData();
    formData.append('file', files[0], files[0].name);
    return this.http
      .post<LoadFileProcess>(url, formData)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  confirmUser(files: File[]) {
    this.statusUpload = true;
    this.errores = [];
    const url = `${this.URI_API}/debt/load/${this.service.name}/${this.idProcess}`;
    const formData = new FormData();
    formData.append('file', files[0], files[0].name);
    return this.http
      .post<LoadFileProcess>(url, formData)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  StatusExcel(id: number): Observable<ProcessStatus> {
    const url = `${this.URI_API}/debt/process/${id}/status`;
    return this.http
      .get<ProcessStatus>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  GetTemplate(): Observable<Blob> {
    const serviceName = encodeURIComponent(this.service.name);
    const url = `${this.URI_API}/debt/template?service=${serviceName}`;
    return this.http.get(url, {
      responseType: 'blob',
    });
  }

  GetLastProcess() {
    const url = `${this.URI_API}/debt/process/last`;
    return this.http.get<LastProcessStatus>(url).pipe(
      map((result) => {
        if (
          result.status !== 'COMPLETED' &&
          result.status !== 'REJECTED' &&
          result.status !== 'FAILED'
        ) {
          this.statusUpload = true;
          this.idProcess = result.id;
        }
        return result;
      }),
    );
  }
}
